var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorizationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.135,
    height: 24.985,
    viewBox: "0 0 21.135 24.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Authorization_Icon",
    "data-name": "Authorization Icon",
    transform: "translate(-12.93 -10.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11615",
    "data-name": "Group 11615",
    transform: "translate(9.618 9.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 4.739,
    cy: 4.739,
    r: 4.739,
    transform: "translate(7.335 1)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49467",
    "data-name": "Path 49467",
    d: "M16.971,18.109a6.1,6.1,0,0,1,2.1-.441c1.451-2.452-3.646-4.5-5.547-4.339h-2.9a7.329,7.329,0,0,0-7.312,7.321v.974a3.739,3.739,0,0,0,3.739,3.739h5.022a1.5,1.5,0,0,0,.833-.242,7.454,7.454,0,0,1-.067-.958,6.5,6.5,0,0,1,4.131-6.055ZM23.6,20.466a1.55,1.55,0,0,0-1.841.291l-3.39,3.515-1.141-1.124a1.564,1.564,0,0,0-2.182,2.24L17.32,27.6a1.565,1.565,0,0,0,1.091.441h.017a1.552,1.552,0,0,0,1.1-.475l4.481-4.639a1.661,1.661,0,0,0,.416-.791v-.025a1.557,1.557,0,0,0-.458-1.391,1.392,1.392,0,0,0-.366-.258Z",
    transform: "translate(0 -2.059)",
    fill: "#4165f6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizationIcon);
export default __webpack_public_path__ + "static/media/Authorization Icon.99c04a92389077250e6dd5c215c6be1c.svg";
export { ForwardRef as ReactComponent };